export const USER_ROLES = {
    RoleSuperAdmin: 1,
    RoleAdmin: 2,
    RoleUser: 3
}